import { Typography } from '@mui/material';

import { useCustomerInfo } from '@/api/customers';
import { AlertChip } from '@/components/AlertChip';
import { SummaryCard, SummaryCardBody, SummaryCardProps } from '@/components/ui/SummaryCard';
import { errorMessage } from '@/utils';

export const PaymentEmailCard = ({ ...props }: Pick<SummaryCardProps, 'sx'>) => {
    const { data: customerInfo, isError, error, isPending } = useCustomerInfo();
    const billingEmail = customerInfo?.data?.email;

    return (
        <SummaryCard title="Billing email address" isLoading={isPending} {...props}>
            <SummaryCardBody>
                {isError ? (
                    <AlertChip severity="error" label={errorMessage(error, 'Unable to load billing email')} />
                ) : (
                    <Typography variant="inherit" sx={{ overflowWrap: 'anywhere' }}>
                        {billingEmail ?? 'No email address on file'}
                    </Typography>
                )}
            </SummaryCardBody>
        </SummaryCard>
    );
};
